const OriginalFormatBadges = ({ formats = [] }) =>
  [...new Set(formats.map((format) => format.toUpperCase()))].map((format) => (
    <span className="originalFormatBadge" key={format}>
      {format}
    </span>
  ));

export default OriginalFormatBadges;
